<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <router-link tag="li" :to="{ name: 'pcode'}">
              <a>個人コード一覧 </a>
            </router-link>
            <li class="active">新規個人コード登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>新規個人コード登録</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-success" v-if="message_success">
            {{ message_success }}
          </div>
          <div class="alert alert-danger" v-if="message_error">
            {{ message_error }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="form-group">
                <div class="col-md-offset-2 col-md-10"><span id="name_error" class="error_m"></span></div>
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">個人コード</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" placeholder="個人コード" v-model="pcodeInfor.pCodeId">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">コード種別</label>
                <div class="col-sm-10">
                  <select class="form-control" data-placeholder="ユーザー選択" v-model="pcodeInfor.type">
                    <option v-for="item in listType" v-bind:value="item.value" v-bind:key="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-10">
                  <button class="btn-cusstom green-btn" type="button" href="#userList" data-toggle="modal">ユーザーの選択</button>
                  <button class="btn-cusstom black-btn" type="button" @click="removeUser()">ユーザーの関連付け解除</button>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ユーザーID</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" disabled placeholder="ユーザーID" v-model="pcodeInfor.userId">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ユーザー名</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control input-sm" id="name" disabled placeholder="ユーザー名" v-model="pcodeInfor.name">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1">ステータス</label>
                <div class="col-sm-1">
                  <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="pcodeInfor.isValid">
                  <span class="lbl"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label no-padding-right" for="form-field-1"></label>
                <div class="col-sm-10">
                  <router-link :to="{ name: 'pcode'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="validateBeforeSubmit">
                    保存
                  </button>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <div id="userList" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">ユーザーの関連付けを追加</h3>
            <span class="input-icon search-box">
              <input type="text" placeholder="ユーザーID、ユーザー名検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
              <i class="ace-icon fa fa-search nav-search-icon"></i>
            </span>
            <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
          </div>
          <div class="modal-body">
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="listUser!=null">
              <thead>
                <tr>
                  <th></th>
                  <th>ユーザーID</th>
                  <th>ユーザー名</th>
                  <th class="center">ステータス</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in listUser" :key="index">
                <tr>
                  <td class="center">
                    <label class="pos-rel">
                      <input type="radio" class="ace" :value="item.userId" v-model="selectedUserId">
                      <span class="lbl"></span>
                    </label>
                  </td>
                  <td>
                    {{item.userId}}
                  </td>
                  <td>
                    {{item.name}}
                  </td>
                  <td class="center">
                    <span v-if="item.isValid">有効</span>
                    <span v-else >無効</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
              <thead>
                <tr>
                  <th style="width:150px">ユーザーID</th>
                  <th>ユーザー名</th>
                  <th class="center">ステータス</th>
                </tr>
              </thead>
              <tbody>
                <tr><td colspan="3">データーはありません</td></tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div class="row pd-t-10">
              <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
                <paginate
                  :page-count="pages"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="handleCurrentChange"
                  :prev-text="'<<'"
                  :next-text="'>>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
                </paginate>
              </div>
            </div>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" @click="addUserInfor()" data-dismiss="modal">選択</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      errorMessageLogs: '',
      pcodeInfor: {
        pCodeId: '',
        userId: '',
        name: '',
        type: 0,
        isValid: true
      },
      selectedUserId: '',
      listUser: null,
      listType: [
        { text: 'NFCカード', value: 0 },
        { text: 'テンキー入力', value: 1 }
      ],
      pages: 0,
      listQuery: {
        currPage: 1
      },
      success: false,
      isDisabled: false,
      flagU: false,
      flag: false,
      message_success: '',
      message_error: '',
      loading: false
    }
  },
  mounted () {
    this.getListUser()
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
  },
  methods: {
    removeUser () {
      this.pcodeInfor.userId = ''
      this.pcodeInfor.name = ''
    },
    addUserInfor () {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(this.selectedUserId))
        .then(response => {
          vm.pcodeInfor.userId = response.body.users[0].userId
          vm.pcodeInfor.name = response.body.users[0].name
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleCurrentChange (val) {
      this.flag = true
      this.listQuery.currPage = val
      this.getListUser()
    },
    getListUser () {
      var keyword = $('.nav-search-input').val()
      keyword = keyword.replace(/\s/g, ',')
      this.$http.get(Config.USERS_LIST_API + '?limit=25&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=userId,name' + '&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.flag = false
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / 25)
            this.listUser = response.body.users
          } else {
            this.flag = false
            this.listUser = null
            this.pages = 0
            this.loading = false
          }
        })
        .catch((error) => {
          this.listUser = null
          this.pages = 0
          this.flag = false
          console.log(error)
        })
    },
    validateBeforeSubmit () {
      this.flag = true
      if (this.pcodeInfor.pCodeId === null || this.pcodeInfor.pCodeId === '') {
        $('#name_error').html('個人コードは必須です。')
        $('#name').addClass('error')
        this.flagU = false
      } else {
        $('#name_error').html('')
        $('#name').removeClass('error')
        this.flagU = true
      }
      var english = /^[A-Za-z0-9]*$/
      if (this.pcodeInfor.pCodeId !== null && this.pcodeInfor.pCodeId !== '') {
        if (!this.pcodeInfor.pCodeId.match('^(?=.*[a-z]).{4,64}$') || !english.test(this.pcodeInfor.pCodeId)) {
          $('#name_error').html('個人コードは半角英数字を組み合わせた4文字以上64文字以内で入力してください。')
          $('#name').addClass('error')
          this.flag = false
        } else {
          $('#name_error').html('')
          $('#name').removeClass('error')
          this.flag = true
        }
      }
      if (this.flag && this.flagU) {
        this.addPcode()
      }
    },
    search () {
      this.loading = true
      var keyword = $('.nav-search-input').val()
      keyword = keyword.replace(/\s/g, ',')
      this.$http.get(Config.USERS_LIST_API + '?limit=' + 25 + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=userId,name' + '&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / 25)
            this.listUser = response.body.users
          } else {
            this.listUser = null
            this.pages = 0
            this.loading = false
          }
        })
        .catch((error) => {
          this.listUser = null
          this.pages = 0
          this.loading = false
          console.log(error)
        })
    },
    reset () {
      this.pcodeInfor.pCodeId = ''
      this.pcodeInfor.userId = ''
      this.pcodeInfor.name = ''
      this.pcodeInfor.type = 0
      this.pcodeInfor.isValid = true
    },
    addPcode () {
      this.loading = true
      var pcodeInfor = {
        pCodeId: this.pcodeInfor.pCodeId,
        userId: this.pcodeInfor.userId,
        type: this.pcodeInfor.type,
        isValid: this.pcodeInfor.isValid
      }
      console.log(pcodeInfor)
      this.$http.post(Config.PCODE_LIST_API, pcodeInfor)
        .then(response => {
          if (response.body.message === 'Success') {
            this.loading = false
            this.reset()
            this.errorMessageLogs = ''
            this.message_success = Config.ADD_PCODE_API_SUCCESS
            this.message_error = ''
          } else {
            this.loading = false
            this.message_error = Config.ADD_API_ERROR
            this.message_success = ''
          }
        })
        .catch((error) => {
          this.loading = false
          this.message_success = ''
          switch (error.status) {
            case 400:
              this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message_error = '個人コードの追加権限がありません。'
              break
            case 404:
              this.message_error = '該当するデーターがありません。'
              break
            case 409:
              this.message_error = '入力された個人コードは既に使用されています。他の個人コードを入力してください。'
              break
            case 420:
              this.message_error = '個人コード登録数が上限に達しています。'
              break
            case 500:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>
<style>
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    border-radius: 10px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41!important
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
  .field{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    background: #ABBAC3;
  }
</style>



// WEBPACK FOOTER //
// src/views/pcode/PcodeAdd.vue